import React, { useState } from 'react';
import { OFFICES } from './helpers';

export function StaffModal({ staff, onClose, onSubmit }) {
  const isEdit = !!staff;
  const [name, setName] = useState(isEdit ? (staff.name || '') : '');
  const [office, setOffice] = useState(isEdit ? (staff.office || 'Karaikudi') : 'Karaikudi');
  const [rate, setRate] = useState(isEdit ? (staff.rate ?? 500) : 500);
  const [phone, setPhone] = useState(isEdit ? (staff.phone || '') : '');
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!name.trim()) return;
    setSaving(true);
    try { await onSubmit({ mode: isEdit ? 'edit' : 'create', id: isEdit ? staff.user_id : undefined, data: { name: name.trim(), office, rate: Number(rate) || 500, phone: phone.trim() } }); } finally { setSaving(false); }
  };

  return (
    <div className="modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="modal" style={{ maxWidth: 400 }} data-testid="staff-modal">
        <div className="modal-header"><h3>{isEdit ? 'Edit Staff' : 'Add Staff'}</h3><button className="modal-close" onClick={onClose}>&times;</button></div>
        <div className="field"><label className="field-label">Name</label><input className="field-input" value={name} onChange={(e) => setName(e.target.value)} data-testid="staff-name" /></div>
        <div className="field"><label className="field-label">Office</label><select className="field-input" value={office} onChange={(e) => setOffice(e.target.value)} data-testid="staff-office">{OFFICES.map((o) => <option key={o}>{o}</option>)}</select></div>
        <div className="field"><label className="field-label">Phone (optional)</label><input className="field-input" type="tel" inputMode="numeric" maxLength={10} value={phone} onChange={(e) => setPhone(e.target.value.replace(/[^0-9]/g, '').slice(0, 10))} data-testid="staff-phone" /></div>
        <div className="field"><label className="field-label">Rate per Completed Work (&#8377;)</label><input className="field-input" type="number" value={rate} onChange={(e) => setRate(e.target.value)} data-testid="staff-rate" /></div>
        <div className="modal-actions"><button className="btn-outline" onClick={onClose} disabled={saving}>Cancel</button><button className="btn-primary" onClick={save} disabled={saving || !name.trim()} data-testid="save-staff-btn">{saving ? 'Saving…' : isEdit ? 'Save Changes' : 'Add Staff'}</button></div>
      </div>
    </div>
  );
}

export function PinModal({ user, onClose, onSave }) {
  const [step, setStep] = useState(1);
  const [pin1, setPin1] = useState('');
  const [pin2, setPin2] = useState('');
  const [err, setErr] = useState('');
  const [saving, setSaving] = useState(false);

  const next = () => { if (pin1.length !== 6) { setErr('Enter a 6-digit PIN'); return; } setErr(''); setStep(2); };
  const save = async () => {
    if (pin2 !== pin1) { setErr('PINs do not match'); return; }
    setSaving(true);
    try { await onSave(user, pin1); } catch (e) { setErr(e.message); } finally { setSaving(false); }
  };
  const pinInput = (val, set, testid) => (
    <input className="field-input" type="tel" inputMode="numeric" maxLength={6} value={val}
      onChange={(e) => { set(e.target.value.replace(/[^0-9]/g, '').slice(0, 6)); setErr(''); }}
      style={{ fontSize: 22, fontWeight: 800, letterSpacing: 8, textAlign: 'center', fontFamily: 'var(--font-mono)' }} data-testid={testid} autoFocus />
  );

  return (
    <div className="modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="modal" style={{ maxWidth: 360 }} data-testid="pin-modal">
        <div className="modal-header"><h3>{user.has_pin ? 'Change' : 'Set'} PIN — {user.name}</h3><button className="modal-close" onClick={onClose}>&times;</button></div>
        {step === 1 ? (
          <>
            <div className="field"><label className="field-label">Enter new 6-digit PIN</label>{pinInput(pin1, setPin1, 'pin-step1')}</div>
            {err && <div style={{ color: '#dc2626', fontSize: 12, fontWeight: 600 }}>{err}</div>}
            <div className="modal-actions"><button className="btn-outline" onClick={onClose}>Cancel</button><button className="btn-primary" onClick={next} data-testid="pin-next">Next</button></div>
          </>
        ) : (
          <>
            <div className="field"><label className="field-label">Confirm PIN</label>{pinInput(pin2, setPin2, 'pin-step2')}</div>
            {err && <div style={{ color: '#dc2626', fontSize: 12, fontWeight: 600 }}>{err}</div>}
            <div className="modal-actions"><button className="btn-outline" onClick={() => setStep(1)}>Back</button><button className="btn-primary" onClick={save} disabled={saving} data-testid="pin-save">{saving ? 'Saving…' : 'Save PIN'}</button></div>
          </>
        )}
      </div>
    </div>
  );
}
